import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { FastField, Field } from 'formik';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { InputLabel, Tabs, Tab, Button } from '@material-ui/core';
import _e from 'common/localeUtil';
import TextInputField from './form/TextInputField';
import LabelValueComponent from './LabelValueComponent';
import FieldWrapper from './form/FieldWrapper';
import { setContentGrapesJSComponent, setStyleGrapesJSComponent } from '../utils';
import { a11yProps, TabPanel } from './tab/tab';

const useStyles = makeStyles(() => ({
	form: {
		'& .section-title': {
			marginBottom: '1rem'
		},
		'& .input': {
			height: '2.5rem'
		},
		'& .height2rem': {
			height: '2rem'
		}
	},
	ebookUrlLabel: {
		flex: 1
	},
	ebookUrlValue: {
		flex: 3,
		'& .control': {
			width: '100%'
		}
	},
	buttonLabelLabel: {
		flex: 1
	},
	buttonLabelValue: {
		flex: 2,
		'& .control': {
			width: '100%'
		}
	},
	useGMEbookWrapper: {
		textAlign: 'right'
	},
	useGMEbook: {
		textTransform: 'initial'
	},
	popupLabel: {
		flex: 1
	},
	popupValue: {
		flex: 6,
		'& .control': {
			width: '100%'
		}
	}
}));

const EbookSettings = ({ from, setFieldValue }) => {
	const classes = useStyles();
	const country = useStoreState(state => state.template?.adviserData?.country);
	const [selectedTab, setSelectedTab] = useState(0);
	const ebook = useStoreState(state => state.template.ebook);
	const setEbook = useStoreActions(actions => actions.template.setEbook);

	const handleChange = (event, newValue) => {
		setSelectedTab(newValue);
	};

	useEffect(() => {
		// console.log('ContactSettings useEffect', contactForm);
		// setContactFormToTemplate(contactForm);
	});

	const handleOnChange = part => value => {
		// console.log('ContactSettings handleOnChange', social, value);
		setEbook({
			...ebook,
			[part]: value
		});
		if (part === 'buttonLabel') {
			setContentGrapesJSComponent('#section-ebook .ebook-download-button', value);
		} else if (part === 'popupTitle') {
			setContentGrapesJSComponent('.ebook-modal .modal-card-title', value);
		} else if (part === 'popupMessage') {
			setContentGrapesJSComponent('.ebook-modal .popup-message', value);
		}
	};

	const handleColorChanged = part => hex => {
		console.log('EbookSettings handleColorChanged', part, hex);
		if (part === 'header') {
			setStyleGrapesJSComponent('#section-ebook .ebook-title', { color: hex });
		} else if (part === 'body') {
			setStyleGrapesJSComponent('#section-ebook', { color: hex });
		} else if (part === 'buttonTextColor') {
			setStyleGrapesJSComponent('#section-ebook .ebook-download-button', { color: hex });
		} else if (part === 'buttonBackgroundColor') {
			setStyleGrapesJSComponent('#section-ebook .ebook-download-button', {
				background: `${hex} !important;`
			});
		}
		// else if (part === 'socialIconsColor') {
		// 	setStyleGrapesJSComponentUsingAddStyle(`
		// 		.social svg path {
		// 		   fill: ${hex};
		// 		}
		// 		.social {
		// 		  color: ${hex};
		// 		}
		// 	`);
		// }
	};

	const useGMEbook = () => {
		console.log('useGMEbook');

		const ebookURL =
			country === 'TH'
				? 'https://static.goalsmapper.com/public/platform/agent_website/ebook/goalsmapper_ebook_body_th.pdf'
				: 'https://static.goalsmapper.com/public/platform/agent_website/ebook/goalsmapper_ebook_body.pdf';

		setFieldValue('ebook.ebookUrl', ebookURL);
	};

	const {
		buttonTextColor = '#000000',
		buttonBackgroundColor = '#000000',
		headerColor = '#000000',
		textColor = '#000000'
	} = ebook || {};
	// console.log('ContactSettings rerender', from, headerColor, textColor);

	return (
		<Field name="ebook" as={`div`}>
			<div className={classes.form}>
				<Tabs
					value={selectedTab}
					onChange={handleChange}
					indicatorColor="primary"
					textColor="primary"
					variant="scrollable"
					scrollButtons="auto"
					aria-label="scrollable auto tabs example"
				>
					<Tab label={_e('ebook')} {...a11yProps(0)} />
					<Tab label={_e('button')} {...a11yProps(1)} />
					<Tab label={_e('popup')} {...a11yProps(2)} />
				</Tabs>
				<TabPanel value={selectedTab} index={0}>
					<LabelValueComponent
						label={<InputLabel>{_e('header_color')}</InputLabel>}
						value={
							<FastField
								defaultHex={headerColor}
								name="headerColor"
								component={FieldWrapper}
								control="colorpicker"
								callback={handleColorChanged('header')}
								from={from}
							/>
						}
					/>
					<LabelValueComponent
						label={<InputLabel>{_e('text_color')}</InputLabel>}
						value={
							<FastField
								defaultHex={textColor}
								name="textColor"
								component={FieldWrapper}
								control="colorpicker"
								callback={handleColorChanged('body')}
								from={from}
							/>
						}
					/>
					<LabelValueComponent
						label={<InputLabel>{`${_e('ebook')} URL`}</InputLabel>}
						value={<TextInputField name="ebook.ebookUrl" placeholder="" />}
						labelClasses={classes.ebookUrlLabel}
						valueClasses={classes.ebookUrlValue}
					/>
					<div className={classes.useGMEbookWrapper}>
						<Button
							variant="text"
							classes={{ label: classes.useGMEbook }}
							size="small"
							onClick={useGMEbook}
							id="use-gm-ebook"
						>
							{_e('use_goalsmapper_ebook')}
						</Button>
					</div>
				</TabPanel>
				<TabPanel value={selectedTab} index={1}>
					<LabelValueComponent
						label={<InputLabel>{_e('button_label')}</InputLabel>}
						value={
							<TextInputField
								name="buttonLabel"
								placeholder=""
								onChangeCallBack={handleOnChange('buttonLabel')}
							/>
						}
						labelClasses={classes.buttonLabelLabel}
						valueClasses={classes.buttonLabelValue}
					/>
					<LabelValueComponent
						label={<InputLabel>{_e('button_text_color')}</InputLabel>}
						value={
							<FastField
								defaultHex={buttonTextColor}
								name="buttonTextColor"
								component={FieldWrapper}
								control="colorpicker"
								callback={handleColorChanged('buttonTextColor')}
								from={from}
							/>
						}
					/>
					<LabelValueComponent
						label={<InputLabel>{_e('button_background_color')}</InputLabel>}
						value={
							<FastField
								defaultHex={buttonBackgroundColor}
								name="buttonBackgroundColor"
								component={FieldWrapper}
								control="colorpicker"
								callback={handleColorChanged('buttonBackgroundColor')}
								from={from}
							/>
						}
					/>
				</TabPanel>
				<TabPanel value={selectedTab} index={2}>
					<LabelValueComponent
						label={<InputLabel>{_e('title')}</InputLabel>}
						value={
							<TextInputField
								name="popupTitle"
								placeholder=""
								onChangeCallBack={handleOnChange('popupTitle')}
							/>
						}
						labelClasses={classes.popupLabel}
						valueClasses={classes.popupValue}
					/>
					<LabelValueComponent
						label={<InputLabel>{_e('message')}</InputLabel>}
						value={
							<TextInputField
								name="popupMessage"
								placeholder=""
								onChangeCallBack={handleOnChange('popupMessage')}
							/>
						}
						labelClasses={classes.popupLabel}
						valueClasses={classes.popupValue}
					/>
				</TabPanel>
			</div>
		</Field>
	);
};

EbookSettings.propTypes = {
	from: PropTypes.string,
	sectionId: PropTypes.string,
	setFieldValue: PropTypes.func
};

export default EbookSettings;
